<template>
    <div @click.stop="prevent">
        <div v-html="description" />
        <div v-if="reason">
            <small
                >{{ trans('activity.stakeholder.deleted.reason') }} <span class="text-muted">{{ reason }}</span></small
            >
        </div>
        <div v-if="newAssignee">
            <small
                >{{ trans('activity.stakeholder.new_assignee') }} <span class="text-muted">{{ newAssignee.name }}</span></small
            >
        </div>
    </div>
</template>
<script>
export default {
    name: 'Stakeholder',
    props: {
        item: {},
    },
    computed: {
        description() {
            return this.item.description;
        },
        reason() {
            return this.item.properties?.reason;
        },
        newAssignee() {
            return this.item.properties?.new;
        },
    },
    methods: {
        prevent(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        },
    },
};
</script>
